import { render, staticRenderFns } from "./RelationOrderInfo.vue?vue&type=template&id=114e915a"
import script from "./RelationOrderInfo.vue?vue&type=script&lang=js"
export * from "./RelationOrderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports